import { reactive } from 'vue'

export const store = reactive({
  siteMap: null,
  pageContents: [],
  navigationQuery: [],
  currentPage: null,
  currentPageColor: null,
  pageContent: null,
  host: process.env.VUE_APP_CMS_HOST,
  envHost: process.env.VUE_APP_CMS_HOST,
  imageUrl: "",

  content: null
})